import { useState } from "react";
import { router } from "@inertiajs/react";
import I from "../../components/Icons";
import { common, pick } from "../../lib/i18n";

interface Props {
  errors?: string[];
  minimum_password_length: number;
}

const copy = {
  pl: {
    heading: "Ustaw swoje hasło",
    hint: "To Twoje pierwsze logowanie. Zanim przejdziesz dalej, ustaw własne hasło.",
    submit: "Ustaw hasło i kontynuuj",
  },
  en: {
    heading: "Set your password",
    hint: "This is your first sign-in. Set your own password before you continue.",
    submit: "Set password and continue",
  },
};

export default function SetPassword({ errors = [], minimum_password_length }: Props) {
  const t = pick(copy);
  const c = common();
  const [form, setForm] = useState({ password: "", password_confirmation: "" });

  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    router.put("/password_change", { user: form });
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", background: "var(--bg)", padding: 24 }}>
      <div style={{ width: "100%", maxWidth: 400 }}>
        <div className="logo" style={{ display: "inline-flex", marginBottom: 32 }}>
          <span className="logo-mark" />
          <span>AvantoAI</span>
        </div>

        <div className="panel">
          <div className="panel-hd"><h3>{t.heading}</h3></div>
          <div className="panel-body">
            <p style={{ fontSize: 12.5, color: "var(--muted)", marginBottom: 14 }}>{t.hint}</p>

            {errors.length > 0 && (
              <div style={{ marginBottom: 14, padding: "8px 12px", background: "oklch(0.62 0.20 25 / 0.08)", border: "1px solid oklch(0.62 0.20 25 / 0.3)", borderRadius: "var(--radius)", fontSize: 12, color: "var(--danger)" }}>
                {errors.map((e, i) => <div key={i}>{e}</div>)}
              </div>
            )}

            <form onSubmit={submit}>
              <div className="field">
                <label>{c.auth.newPassword}</label>
                <input
                  className="input"
                  type="password"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  minLength={minimum_password_length}
                  required
                  autoFocus
                />
              </div>
              <div className="field" style={{ marginBottom: 18 }}>
                <label>{c.auth.confirmNewPassword}</label>
                <input
                  className="input"
                  type="password"
                  value={form.password_confirmation}
                  onChange={(e) => setForm({ ...form, password_confirmation: e.target.value })}
                  minLength={minimum_password_length}
                  required
                />
              </div>
              <button type="submit" className="btn btn-accent" style={{ width: "100%", justifyContent: "center", height: 36 }}>
                {I.spark} {t.submit}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
